import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ApiSecretKeyComponent } from './api-secret-key';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.api-secret-key', {
            url: '/api-secret-key',
            ncyBreadcrumb: {
                label: 'Api Secret Key',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Api Secret Key'
            },
            'views': {
                'homeContent': {
                    template: '<api-secret-key flex="100"></api-secret-key>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ApiSecretKeyModule: string = ng
    .module('api-secret-key', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('apiSecretKey', ApiSecretKeyComponent)
    .config(stateConfig)
    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/api-secret-key/api-secret-key.module.ts